import { render, staticRenderFns } from "./Operations.vue?vue&type=template&id=61483570&scoped=true"
import script from "./Operations.vue?vue&type=script&lang=ts"
export * from "./Operations.vue?vue&type=script&lang=ts"
import style0 from "./Operations.vue?vue&type=style&index=0&id=61483570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61483570",
  null
  
)

export default component.exports